export default __webpack_public_path__ + "static/media/login-hero@2x.fb46bcdf.png";